"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var dx_react_grid_1 = require("@devexpress/dx-react-grid");
var dx_react_grid_material_ui_1 = require("@devexpress/dx-react-grid-material-ui");
var antd_1 = require("antd");
var usersList_1 = require("common/global/usersList");
var moment_1 = __importDefault(require("moment"));
var exportWarehouseItemsTableToExcel_1 = require("portal/components/Grid/helpers/exportWarehouseItemsTableToExcel");
var hasWarehousePermission_1 = require("portal/pages/Projects/hasWarehousePermission");
var defaultDevExtremeGridComponents_1 = __importDefault(require("portal/utils/defaultDevExtremeGridComponents"));
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var PrescriptionPrint_1 = __importDefault(require("../PrescriptionPrint"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
var warehousePrescriptionConsumptionOperationsSlice_1 = require("src/features/warehousePrescriptionConsumptionOperations/warehousePrescriptionConsumptionOperationsSlice");
var warehousePrescriptionConsumptionOperationItemsSlice_1 = require("src/features/warehousePrescriptionConsumptionOperationItems/warehousePrescriptionConsumptionOperationItemsSlice");
var RowDetail = function (_a) {
    var row = _a.row;
    var data = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehousePrescriptionConsumptionOperationItems; }).data;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, react_1.useEffect)(function () {
        dispatch((0, warehousePrescriptionConsumptionOperationItemsSlice_1.fetchItemsByOperationId)(row.id));
    }, [dispatch]);
    var rows = (data !== null && data !== void 0 ? data : []).map(function (item) { return (__assign(__assign({}, item), { id: item.id })); });
    var columns = [
        { name: "cachedProductName", title: t("products.productName") },
        { name: "cachedProductUnitName", title: t("common.unit") },
        { name: "cachedProductDescription", title: t("products.description") },
        { name: "batchNumber", title: t("warehouse.batchNumber") },
        { name: "stockNumber", title: t("warehouse.stockNumber") },
        { name: "quantity", title: t("common.quantity") },
    ];
    return ((0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: rows, columns: columns }, { children: [(0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.Table, {}), (0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableHeaderRow, {})] })));
};
function WarehousePrescriptionConsumeOperationsTable(props) {
    var _this = this;
    var _a = (0, reduxHooks_1.useAppSelector)(function (state) { return state.warehousePrescriptionConsumptionOperations; }), data = _a.data, status = _a.status;
    var dispatch = (0, reduxHooks_1.useAppDispatch)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var startOfToday = (0, moment_1.default)();
    var endOfToday = (0, moment_1.default)();
    var _b = (0, react_1.useState)(startOfToday.startOf("day")), startDate = _b[0], setStartDate = _b[1];
    var _c = (0, react_1.useState)(endOfToday.endOf("day")), endDate = _c[0], setEndDate = _c[1];
    var warehouseId = props.warehouseId;
    (0, react_1.useEffect)(function () {
        dispatch((0, warehousePrescriptionConsumptionOperationsSlice_1.fetchWarehousePrescriptionConsumptionOperationsByDate)({
            warehouseId: warehouseId,
            gt: startDate.toISOString(),
            ls: endDate.toISOString(),
            byField: "createdAt",
        }));
        var unsubscribe = (0, warehousePrescriptionConsumptionOperationsSlice_1.subscribeToPrescriptionConsumptionOperations)(dispatch, warehouseId);
        return function () {
            unsubscribe();
        };
    }, [dispatch, startDate, endDate]);
    var warehousePrescriptionConsumptionOperations = (0, react_1.useMemo)(function () {
        return data.map(function (x, idx) {
            var data = x;
            return __assign(__assign({}, data), { id: x.id, idx: idx });
        });
    }, [data]);
    var print1CbRef = (0, react_1.useRef)();
    var _d = (0, react_1.useState)(), selectedRow = _d[0], setSelectedRow = _d[1];
    var print = (0, react_1.useCallback)(function (row) {
        setSelectedRow(row);
        setTimeout(function () {
            print1CbRef === null || print1CbRef === void 0 ? void 0 : print1CbRef.current();
        }, 1500);
    }, []);
    if (status == "loading") {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var columnsOfReceiveItems = [
        {
            name: "NO",
            title: t("warehouse.NO"),
            getCellValue: function (r) { return parseFloat(r.idx + 1); },
        },
        {
            name: "sessionId",
            title: t("warehouse.sessionId"),
            getCellValue: function (r) {
                return r.sessionId.split(" / ");
            },
        },
        {
            name: "sessionData.cachedPatientName",
            title: t("warehouse.patientName"),
            getCellValue: function (r) {
                return r.sessionData.cached_patient_name;
            },
        },
        {
            name: "notes",
            title: t("common.notes"),
        },
        {
            name: "createdBy",
            title: t("warehouse.createdBy"),
            getCellValue: function (r) { var _a; return (_a = usersList_1.globalUsersData[r.createdBy]) === null || _a === void 0 ? void 0 : _a.name; },
        },
        {
            name: "createdAt",
            title: t("warehouse.createdAt"),
            getCellValue: function (r) {
                return (0, moment_1.default)(r.createdAt).format("DD.MM.YYYY");
            },
        },
        {
            name: "print",
            title: t("common.print"),
            getCellValue: function (r) {
                return ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ type: "primary", onClick: function () { return print(r); } }, { children: t("common.print") })));
            },
        },
    ];
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("span", { children: [t("warehouse.filterStartDate"), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setStartDate(e.startOf("day")); }, value: (0, moment_1.default)(startDate) })] }), (0, jsx_runtime_1.jsxs)("span", { children: [" ", t("warehouse.filterEndDate")] }), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setEndDate(e.endOf("day")); }, value: (0, moment_1.default)(endDate) }), selectedRow ? ((0, jsx_runtime_1.jsx)(PrescriptionPrint_1.default, { kind: "prescriptionTable", printFnRef: print1CbRef, type: "none", session: selectedRow.sessionData, sessionId: selectedRow.sessionId })) : null, (0, jsx_runtime_1.jsxs)(dx_react_grid_material_ui_1.Grid, __assign({ rows: warehousePrescriptionConsumptionOperations, columns: columnsOfReceiveItems, getRowId: function (r) { return r.id; } }, { children: __spreadArray(__spreadArray([(0, jsx_runtime_1.jsx)(dx_react_grid_1.RowDetailState, {})], (0, defaultDevExtremeGridComponents_1.default)({
                    pagination: true,
                    pageSize: 50,
                }), true), [(0, jsx_runtime_1.jsx)(dx_react_grid_material_ui_1.TableRowDetail, { contentComponent: RowDetail }), (0, hasWarehousePermission_1.hasWarehousePermission)(warehouseId, [
                        "exportPrescriptionconsumption",
                    ]) ? ((0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: {
                            position: "absolute",
                            left: "65%",
                            marginTop: 16,
                            zIndex: 999,
                        }, onClick: function () { return __awaiter(_this, void 0, void 0, function () {
                            var fileName, fields, titles;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        fileName = "Prescription consumption Table";
                                        fields = [
                                            "warehouseId",
                                            "sessionId",
                                            "createdBy",
                                            "notes",
                                            "createdAt",
                                        ];
                                        titles = [
                                            "Warehouse",
                                            "Session id",
                                            "Created by",
                                            "Notes",
                                            "Created At",
                                        ];
                                        return [4 /*yield*/, (0, exportWarehouseItemsTableToExcel_1.exportWarehouseItemsTableToExcel)(warehousePrescriptionConsumptionOperations, fields, titles, fileName)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); } }, { children: t("common.exportToExcel") }))) : null], false) }))] }));
}
exports.default = WarehousePrescriptionConsumeOperationsTable;
